var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.731,
    height: 56.729,
    viewBox: "0 0 56.731 56.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mood-changes",
    transform: "translate(-11.98 -12.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16209",
    "data-name": "Path 16209",
    d: "M152.538,205.2c-.6,0-1.148,0-1.694,0-.81-.009-1.148-.341-1.15-1.153q-.007-3.6,0-7.21a3.771,3.771,0,0,1,3.777-3.928c.09,0,.18-.014.292-.024-1.571-2.288-1.508-4.276.156-5.71a3.78,3.78,0,0,1,5.061.137c1.53,1.456,1.539,3.545,0,5.542.355.054.7.087,1.03.161a3.7,3.7,0,0,1,2.923,3.548c.027,2.522.014,5.042.008,7.563,0,.729-.357,1.06-1.107,1.071-.548.008-1.1,0-1.726,0v9.115c0,1-.29,1.285-1.309,1.285q-2.482,0-4.964,0c-.99,0-1.29-.308-1.29-1.317V205.2Zm8.487-1.918c.008-.177.022-.33.022-.482,0-1.988.006-3.977,0-5.965a1.882,1.882,0,0,0-2.021-2.034q-2.688-.012-5.375,0a1.892,1.892,0,0,0-2.065,2.051c-.006,1.988,0,3.977,0,5.965,0,.152.022.3.033.452h.951v-5.482h1.877v15.9h.935v-10.33h1.9v10.32h.954v-16h1.881v5.615h.909Zm-6.532-13.221a1.879,1.879,0,1,0,1.871-1.881,1.88,1.88,0,0,0-1.871,1.881Z",
    transform: "translate(-115.966 -146.138)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16210",
    "data-name": "Path 16210",
    d: "M146.284,12.73a8.508,8.508,0,1,1-8.555,8.433,8.528,8.528,0,0,1,8.555-8.433Zm-.043,1.892a6.618,6.618,0,1,0,6.616,6.546,6.624,6.624,0,0,0-6.616-6.546Z",
    transform: "translate(-105.894 0)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16211",
    "data-name": "Path 16211",
    d: "M272.008,108.54a8.508,8.508,0,1,1-8.519,8.528,8.529,8.529,0,0,1,8.519-8.528Zm-6.627,8.5a6.617,6.617,0,1,0,6.663-6.614A6.632,6.632,0,0,0,265.381,117.044Z",
    transform: "translate(-211.797 -80.682)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16212",
    "data-name": "Path 16212",
    d: "M29,117.095a8.508,8.508,0,1,1-8.5-8.545,8.521,8.521,0,0,1,8.5,8.545Zm-1.89-.046a6.617,6.617,0,1,0-6.651,6.627,6.623,6.623,0,0,0,6.651-6.627Z",
    transform: "translate(0 -80.69)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16213",
    "data-name": "Path 16213",
    d: "M187.692,132.68V134.5H185.86V132.68Z",
    transform: "translate(-146.425 -101.01)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16214",
    "data-name": "Path 16214",
    d: "M187.685,156.62v1.825H185.85V156.62Z",
    transform: "translate(-146.417 -121.17)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16215",
    "data-name": "Path 16215",
    d: "M60.05,230.319V228.5h1.817v1.819Z",
    transform: "translate(-40.48 -181.701)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16216",
    "data-name": "Path 16216",
    d: "M311.53,230.338V228.53h1.838v1.808Z",
    transform: "translate(-252.252 -181.726)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16217",
    "data-name": "Path 16217",
    d: "M85.856,248.4H84.04V246.58h1.816Z",
    transform: "translate(-60.682 -196.926)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16218",
    "data-name": "Path 16218",
    d: "M287.61,248.289V246.47h1.817v1.819Z",
    transform: "translate(-232.109 -196.833)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16219",
    "data-name": "Path 16219",
    d: "M109.816,266.357H108V264.54h1.816Z",
    transform: "translate(-80.859 -212.05)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16220",
    "data-name": "Path 16220",
    d: "M265.518,266.278H263.71V264.44h1.808Z",
    transform: "translate(-211.983 -211.966)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16226",
    "data-name": "Path 16226",
    d: "M169.572,70.28H167.75a3.77,3.77,0,0,1,5.492-3.333,3.752,3.752,0,0,1,2.073,3.316h-1.844c-.349-1.26-.969-1.851-1.948-1.854-1,0-1.631.6-1.952,1.869Z",
    transform: "translate(-131.175 -45.279)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16227",
    "data-name": "Path 16227",
    d: "M173.86,42.83h1.819v1.828H173.86Z",
    transform: "translate(-136.32 -25.347)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16228",
    "data-name": "Path 16228",
    d: "M199.717,42.92v1.822H197.9V42.92Z",
    transform: "translate(-156.564 -25.423)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16229",
    "data-name": "Path 16229",
    d: "M289.163,164l1.427-1.356c.3.4.628.835.955,1.271l.284-.006c.327-.385.635-.789.987-1.149a.959.959,0,0,1,1.581-.013c.352.341.674.714,1.157,1.232l1.041-1.461c.576.578.992.993,1.4,1.4-.655.685-1.273,1.393-1.961,2.026a.844.844,0,0,1-1.224-.123c-.379-.369-.733-.767-1.157-1.217-.4.4-.753.761-1.115,1.108a1.007,1.007,0,0,1-1.634-.011c-.576-.559-1.148-1.123-1.742-1.7Z",
    transform: "translate(-233.414 -125.985)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16230",
    "data-name": "Path 16230",
    d: "M293.993,137.653l-1.893-1.9,1.3-1.233,1.877,1.986Z",
    transform: "translate(-235.89 -102.56)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16231",
    "data-name": "Path 16231",
    d: "M325.334,136.494c-.455.442-1.029,1-1.606,1.557-.081.079-.171.148-.262.229l-1.276-1.29c.635-.622,1.276-1.252,1.9-1.87l1.241,1.375Z",
    transform: "translate(-261.229 -103.065)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16232",
    "data-name": "Path 16232",
    d: "M43.639,162.56h1.784c.338,2.155-1.852,4.528-4.314,4.7a4.722,4.722,0,0,1-5.04-4.669h1.841a2.682,2.682,0,0,0,1.238,2.239,3.866,3.866,0,0,0,1.822.515c1.424,0,2.428-1.1,2.67-2.781Z",
    transform: "translate(-20.286 -126.172)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16233",
    "data-name": "Path 16233",
    d: "M48.15,138.56h1.8V140.4h-1.8Z",
    transform: "translate(-30.459 -105.962)",
    fill: "#4a13b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16234",
    "data-name": "Path 16234",
    d: "M73.968,140.579H72.16v-1.84h1.808Z",
    transform: "translate(-50.678 -106.113)",
    fill: "#4a13b2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehave);
export default __webpack_public_path__ + "static/media/behave.fba053598c3978323b9bda34149af724.svg";
export { ForwardRef as ReactComponent };